import { usePostHogMediaTechSync } from './usePostHogMediaTechSync';
import { usePostHogSettingsSync } from './usePostHogSettingsSync';

export function PostHogSyncWrapper() {
  usePostHogMediaTechSync();
  usePostHogSettingsSync();

  return null;
}
